import { render, staticRenderFns } from "./Vipbodyguards_list.vue?vue&type=template&id=a084a1e6&scoped=true&"
import script from "./Vipbodyguards_list.vue?vue&type=script&lang=js&"
export * from "./Vipbodyguards_list.vue?vue&type=script&lang=js&"
import style0 from "./Vipbodyguards_list.vue?vue&type=style&index=0&id=a084a1e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a084a1e6",
  null
  
)

export default component.exports